import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { paths } from '@/app/paths';
import { useStore } from '@/store/AppStore';

/**
 * Entrar em outra organização (Administrador da plataforma): limpa o que estava em cache
 * da anterior (acessos, organizações, distribuição) e volta ao Dashboard da escolhida.
 */
export function useSwitchOrg(): (orgId: string) => void {
  const { actions } = useStore();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return (orgId) => {
    queryClient.clear();
    actions.switchOrg(orgId);
    navigate(paths.home);
  };
}
